import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'premium' | 'glass';
}
export function Card({
  className = '',
  variant = 'default',
  children,
  ...props
}: CardProps) {
  const variants = {
    default: 'bg-white rounded-xl shadow-md border border-slate-200/60',
    premium: 'card-premium',
    glass: 'glass rounded-2xl shadow-xl'
  };
  return <div className={`${variants[variant]} transition-premium ${className}`} {...props} data-id="element-359">
      {children}
    </div>;
}
export function CardHeader({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`px-6 py-5 border-b border-slate-100 ${className}`} {...props} data-id="element-360">
      {children}
    </div>;
}
export function CardTitle({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={`text-lg font-semibold text-slate-900 tracking-tight ${className}`} {...props} data-id="element-361">
      {children}
    </h3>;
}
export function CardContent({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`px-6 py-5 ${className}`} {...props} data-id="element-362">
      {children}
    </div>;
}
export function CardFooter({
  className = '',
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={`px-6 py-4 border-t border-slate-100 ${className}`} {...props} data-id="element-363">
      {children}
    </div>;
}